<template>
  <div :class="envMode == 'devel' ? 'block-show' : 'hide'" class="app-block">

  </div>
</template>

<script setup>
import { getCurrentInstance, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useAppStore } from "@/stores/useAppStore";
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();
const store = useAppStore();
const route = useRoute();
const instance = getCurrentInstance();
const { appName, appEnv, apiHost } = instance.appContext.config.globalProperties;

const envMode = ref("devel");
const deviceType = ref("mobile");
const apiUrl = ref("");

const onResize = () => {
  deviceType.value = window.innerWidth > 992 ? "pc" : "mobile";
  store.setDeviceType(deviceType.value);
};

onMounted(() => {
  window.addEventListener("resize", onResize);

  deviceType.value = window.innerWidth > 992 ? "pc" : "mobile";
  store.setDeviceType(deviceType.value);

  const apiUrlItem =
    document.cookie
      .match("(^|;)\\s*" + appName + "-apiUrl\\s*=\\s*([^;]+)")
      ?.pop() || "";
  if (apiUrlItem === "") cookies.set(appName + "-apiUrl", encodeURI(apiHost));
  apiUrl.value = apiHost;

  envMode.value = appEnv ?? "devel";
  store.setEnvMode(envMode.value);

  watch(
    () => route.path,
    () => {
      if (
        (route.path.match("/movie/\\d+") &&
          route.path.match("/movie/\\d+").length > 0) ||
        route.path.match("/movie")
      ) {
        store.setSideBarShow(false);
      } else {
        store.setSideBarShow(true);
      }

      if (route.path !== "/") {
        cookies.set(appName + "-preRoute", encodeURI(route.path));
        store.setPreRoute(encodeURI(route.path));
      }
    }
  );

  store.setAxiosHeaders({
    key: "reqHost",
    val: location.protocol + "//" + location.host,
  });

  if (route.path !== "/") {
    cookies.set(appName + "-preRoute", encodeURI(route.path));
    store.setPreRoute(encodeURI(route.path));
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});
</script>
<style>
.app-block {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
  font-size: 10pt;
  color: #00ff00;
  background-color: #000;
}
</style>
